import React from "react";
import { Helmet } from "react-helmet";

export default function FAQSupport() {
  return (
    <div className="page">
      <Helmet><title>FAQ & Support | RO Service Patna</title></Helmet>
      <h1>FAQ & Support</h1>

      <h3>How fast do you provide service?</h3>
      <p>We offer same-day service in most Patna areas.</p>

      <h3>Which RO brands do you service?</h3>
      <p>Kent, Aquaguard, Livpure, Pureit and all major brands.</p>

      <h3>How can I book a service?</h3>
      <p>You can call, WhatsApp or use the booking form on our website.</p>
    </div>
  );
}
